<ion-content>

    <div class="wrapper" [ngClass]="{ 'mobile': !isDesktopPlatform, 'desktop': isDesktopPlatform }">

        <!-- Desktop Login -->
        <section class="login" *ngIf="isDesktopPlatform; else mobileLogin">
            <div class="rota-logo">
                <img src="/assets/img/icon.png" alt="">
            </div>

            <div class="form-card">
                <div class="welcome-text">
                    <h1>{{ 'Login_Text_Label' | translate }}</h1>
                    <p>{{ 'Login_Text_SignIn' | translate }}</p>
                </div>

                <div class="inputs">
                    <ion-item>
                        <ion-input type="email" [(ngModel)]="emailModel" [placeholder]="'Login_Username_Hint' | translate"
                            (keydown)="desktopKeyboardHandler($event)">
                            <ion-icon slot="start" name="mail-outline" color="medium" size="small" />
                        </ion-input>
                    </ion-item>

                    <ion-item>
                        <ion-input [color]="'primal'" type="password" [(ngModel)]="passwordModel" [placeholder]="'Login_Password_Hint' | translate"
                            (keydown)="desktopKeyboardHandler($event)">
                            <ion-icon slot="start" name="key-outline" color="medium" size="small"></ion-icon>
                            <ion-input-password-toggle slot="end" color="medium"></ion-input-password-toggle>
                        </ion-input>
                    </ion-item>
                </div>

                <div class="buttons">
                    <ion-button ion-button size="large" expand="block" class="open_button" (click)="doDesktopLogin()">
                        <ion-icon slot="start" name="log-in"></ion-icon>
                        {{ 'Login_Login' | translate }}
                    </ion-button>
                </div>
            </div>

            <div class="forgot-password">
                <h4>{{ 'Login_Text_No_Login_Credentials' | translate }}</h4>
                <p>{{ 'Login_Text_Contact_Your_Company' | translate }}</p>
            </div>

        </section>

        <!-- Mobile Login -->
        <ng-template #mobileLogin>
            <section class="login">
                <div class="rota-logo">
                    <img src="assets/img/icon.png" alt="">
                </div>

                <div class="form-card">
                    <div class="welcome-text">
                        <h1>{{ 'Login_Text_Label' | translate }}</h1>
                        <p>{{ 'Login_Text_SignIn' | translate }}</p>
                    </div>

                    <div class="buttons">
                        <ion-button ion-button size="large" expand="block" class="open_button" (click)="doMobileLogin()">
                            <ion-icon slot="start" name="log-in"></ion-icon>
                            {{ 'Login_Login' | translate }}
                        </ion-button>

                        <span>or</span>

                        <ion-button ion-button size="large" expand="block" class="open_button" (click)="doQRLogin()">
                            <ion-icon slot="start" name="qr-code"></ion-icon>
                            {{ 'Login_Text_With_QRCode' | translate }}
                        </ion-button>
                    </div>
                </div>

                <div class="forgot-password">
                    <h4>{{ 'Login_Text_No_Login_Credentials' | translate }}</h4>
                    <p>{{ 'Login_Text_Contact_Your_Company' | translate }}</p>
                </div>
            </section>
        </ng-template>

    </div>
</ion-content>